import { Separator } from '@/components/ui/separator';
import { useNavigate, useParams } from 'react-router-dom';
import { updateChannelGuide, useChannelGuide } from '@/lib/api/channelGuide';
import { useMutation } from '@tanstack/react-query';
import { ChannelForm } from './channelForm';
import { cloneDeep } from 'lodash';
import { Channel, ChannelGuide } from '@/lib/schema/channelGuide';

function submitChannel(data: ChannelGuide) {
  return updateChannelGuide(data.id!, data);
}

export function UpdateChannel() {
  const { channelGuideId, id } = useParams<{
    channelGuideId: string;
    id: string;
  }>();
  const [channelGuide, isLoading] = useChannelGuide(channelGuideId);

  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: submitChannel,
    onSuccess: () => {
      navigate(-1);
    },
    onError: (error) => {
      console.error('Error creating TV controller:', error);
    },
  });

  const onSubmit = (data: any) => {
    const update: ChannelGuide = cloneDeep(channelGuide);
    const index = update.channels.findIndex(
      (channel: Channel) => channel.id === data.id
    );

    if (index !== -1) {
      update.channels[index] = { ...update.channels[index], ...data };
    }

    mutation.mutate(update);
  };

  if (isLoading || !channelGuide) {
    return null;
  }

  return (
    <div className="w-full pb-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Update Channel</h1>
        </div>
      </div>

      <Separator className="my-6" />

      <ChannelForm
        channels={channelGuide.channels || []}
        channel={channelGuide.channels.find(
          (channel: Channel) => channel.id === id
        )}
        mutation={mutation}
        onSubmit={onSubmit}
      />
    </div>
  );
}
